import { EstacionResumenApi, Resumen2Api } from '@/domain/entities/Api'
import { Commit } from '@/store/types'
import { getEnvironments } from '@/environments'
import { client as fetch } from './ClientService'

export interface PronosticoAireInterface {
  getPronosticoAire(): Promise<Commit<Resumen2Api>>
  getEstacionResumen(estacionId: number, periodo: { inicio: string, fin: string }): Promise<Commit<EstacionResumenApi>>
  getLinkDescarga(estacionId: number, periodo: { inicio: string, fin: string }): Promise<Commit<string>>
  generateAPI(estacionId: number, periodo: { inicio: string, fin: string }): string
}

export class PronosticoAireService implements PronosticoAireInterface {
  env = getEnvironments()
  apiUrl: string = this.env.url.API ? this.env.url.API : window.location.origin
  resumen: number = this.env.settings.PRONOSTICO_AIRE.resumen ? this.env.settings.PRONOSTICO_AIRE.resumen : 5;
  constructor (apiUrl?: string) {
    this.apiUrl = apiUrl || this.apiUrl
  }
  async getPronosticoAire (): Promise<Commit<Resumen2Api>> {
    try {
      const response = await fetch(`${this.apiUrl}/api/resumen/${this.resumen}`)
      return { type: 'PRONOSTICO_AIRE_FETCHED', payload: response }
    } catch (e) {
      return { type: 'PRONOSTICO_AIRE_ERROR', payload: e }
    }
  }
  async getEstacionResumen (estacionId: number, periodo: { inicio: string, fin: string }): Promise<Commit<EstacionResumenApi>> {
    try {
      const response = await fetch(this.generateAPI(estacionId, periodo))
      return { type: 'PRONOSTICO_AIRE_ESTACION_FETCHED', payload: response }
    } catch (e) {
      return { type: 'PRONOSTICO_AIRE_ESTACION_ERROR', payload: e }
    }
  }
  async getLinkDescarga (estacionId: number, periodo: { inicio: string, fin: string }): Promise<Commit<string>> {
    const api = `${this.generateAPI(estacionId, periodo)}/descarga`
    return { type: 'PRONOSTICO_AIRE_SET_API_RESUMEN', payload: api }
  }
  generateAPI (estacionId: number, periodo: { inicio: string, fin: string }): string {
    return `${this.apiUrl}/api/estacion/${estacionId}/resumen/${this.resumen}/${periodo.inicio}/${periodo.fin}`
  }
}
